<template>
  <form
    role="search"
    :id="idString"
    method="get"
    :action="searchPage"
    :class="showFilters ? 'showfilters' : ''"
    @submit="onFormSubmit"
  >
    <div class="searchinput">
      <SearchInput
        ref="searchinput"
        :baseApiUrl="baseApiUrl"
        :texts="texts"
        :suggestSokOptions="suggestSokOptions"
        :idString="idString"
        :searchPage="searchPage"
        :showAnswer="showAnswer"
        :useEntypoIcons="useEntypoIcons"
        @searchSubmitted="$emit('searchSubmitted', $event)"
      ></SearchInput>
    </div>
    <SearchFilters
      v-if="showFilters"
      :selectedFilter="selectedFilter"
      :sokFilter="sokFilter"
      :texts="texts"
      @filterSelected="filterSelected"
    ></SearchFilters>
    <SearchFacets
      v-if="showFacets"
      :showFirstFacetAsDropdown="showFirstFacetAsDropdown"
      :selectedFacets="selectedFacets"
      :sokFacets="sokFacets"
      :texts="texts"
      @facetSelected="facetSelected"
      @removeSelectedFacet="removeSelectedFacet"
      @clearSelectedFacets="clearSelectedFacets"
    ></SearchFacets>
  </form>
</template>

<script>
import SearchInput from "./searchinput.vue";
import SearchFilters from "./searchfilters.vue";
import SearchFacets from "./searchfacets.vue";

export default {
  name: "SearchForm",
  props: {
    baseApiUrl: String,
    searchPage: String,
    texts: Object,
    suggestSokOptions: Object,
    idString: String,
    selectedFilter: String,
    selectedFacets: Object,
    sokFilter: Object,
    sokFacets: Object,
    showFilters: {
      type: Boolean,
      default: false,
    },
    showFacets: {
      type: Boolean,
      default: false,
    },
    showFirstFacetAsDropdown: {
      type: Boolean,
      default: false,
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
    useEntypoIcons: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  created() {},
  components: {
    SearchInput,
    SearchFilters,
    SearchFacets,
  },
  methods: {
    filterSelected(selected) {
      this.$emit("filterSelected", selected);
    },
    facetSelected(selected, facetnamn) {
      this.$emit("facetSelected", selected, facetnamn);
    },
    removeSelectedFacet(facetName, value) {
      this.$emit("removeSelectedFacet", facetName, value);
    },
    clearSelectedFacets() {
      this.$emit("clearSelectedFacets");
    },
    onFormSubmit(e) {
      // Om AJAX ska användas, förhindra submit och låt knappen hantera det
      if (this.$refs && this.$refs.searchinput && this.$refs.searchinput.shouldDoAjax) {
        e.preventDefault();
        // Simulera knapptryckning om Enter används
        this.$refs.searchinput.onSubmitSearch(e);
      }
      // Annars klassisk submit
    },
  },
};
</script>
